import * as types from '../constants/actionTypes';
import * as axios from 'axios';
import config from '../config';
import {
  addNotification
} from './notificationActions';
const websocketUrl = config.socketserver.url + ':' + config.server.port;

// example of a thunk using the redux-thunk middleware
export function saveNetowrkSettingsSuccess(settings) {
  return {
    type: types.SAVE_NETWORK_SETTINGS,
    settings: settings
  };
}

export function getNICsSuccess(nics) {
  return {
    type: types.GET_NICS,
    nics: nics
  };
}

export function getAboutSuccess(about) {
  return {
    type: types.GET_ABOUT,
    about: about
  };
}

export function getNICsFailure(error) {
  return {
    type: types.GET_NICS,
    error: error
  };
}

export function resetPasswordSuccess(data) {
  return {
    type: types.RESET_PWD,
    error: data
  };
}
export function resetPasswordFailure(error) {
  return {
    type: types.RESET_PWD,
    error: error
  };
}

export function getSSHSettingsSuccess(state) {
  return {
    type: types.GET_SSH_STATUS,
    enableSSH: state.enableSSH
  };
}

export function getSSHSettingsFailure(error) {
  return {
    type: types.GET_SSH_STATUS,
    error: error
  };
}

export function execServerActionSuccess(data) {
  return {
    type: types.GET_SERVER_ACTION,
    payload: {
      ...data
    }
  };
}

export function getNICs(serviceUrl) {
  const url = serviceUrl + '/network/nic';
  // const url = websocketUrl + '/network/nic';
  return function (dispatch) {
    return axios.get(url, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        //dispatch(addNotification(res.data, 'success'));
        dispatch(getNICsSuccess(res.data));
      })
      .catch(err => {
        let errMsg = err.message;

        if (err.response && err.response.data)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          errMsg = `Unable to connect to the engine service!`;


        dispatch(addNotification(errMsg, 'error'));

        dispatch(getNICsFailure(err))
      });
  }
}

export function getAbout(serviceUrl) {
  const url = serviceUrl + '/about/licensing';
  // const url = websocketUrl + '/about/licensing';
  return function (dispatch) {
    return axios.get(url, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        //dispatch(addNotification(res.data, 'success'));
        dispatch(getAboutSuccess(res.data));
      })
      .catch(err => {
        let errMsg = err.message;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          errMsg = `Unable to connect to the engine service!`;


        dispatch(addNotification(errMsg, 'error'));

        // dispatch(getNICsFailure(err))
      });
  }
}

export function resetPassword(newPasswordObj, serviceUrl) {
  const url = serviceUrl + '/auth/reset';
  // const url = websocketUrl + '/auth/reset';
  return function (dispatch) {
    var user = {};
    user.username = 'appuser';
    user.password = newPasswordObj.password;
    user.newPassword = newPasswordObj.newPassword;
    return axios.post(url, user, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
        dispatch(resetPasswordSuccess(res.data));
      })
      .catch(err => {
        let errMsg = err.message;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          errMsg = `Unable to connect to the engine service!`;


        dispatch(addNotification(errMsg, 'error'));

        // dispatch(resetPasswordFailure(err))
      });
  }
}

export function saveNetworkSettings(newSettings, serviceUrl) {
  const url = serviceUrl + '/network/nic';
  // const url = websocketUrl + '/network/nic';
  return function (dispatch) {
    return axios.post(url, newSettings, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
        dispatch(saveNetowrkSettingsSuccess(res.data));
      })
      .catch(err => {
        let errMsg = err.message;
        var msg;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          msg = `Successfully saved the network setting!`;

        if (msg) {
          dispatch(addNotification(msg, 'success'));
        } else {
          dispatch(addNotification(errMsg, 'error'));
        }

        dispatch(getNICsFailure(err))
      });
  }
}

export function exportContainers(serviceUrl) {
  const url = serviceUrl + '/stream/export';
  return function (dispatch) {
    return axios.get(url, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
        dispatch(saveNetowrkSettingsSuccess(res.data));
      })
      .catch(err => {
        let errMsg = err.message;
        var msg;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          msg = `Successfully exported the stream list!`;

        if (msg) {
          dispatch(addNotification(msg, 'success'));
        } else {
          dispatch(addNotification(errMsg, 'error'));
        }

      });
  }
}

export function getSSHSettings(serviceUrl) {
  const url = serviceUrl + '/server/ssh';
  return function (dispatch) {
    return axios.get(url, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        dispatch(getSSHSettingsSuccess(res.data));
      })
      .catch(err => {
        let errMsg = err.message;

        if (err.response && err.response.data)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          errMsg = `Unable to connect to the engine service!`;


        dispatch(addNotification(errMsg, 'error'));

        dispatch(getSSHSettingsFailure(err))
      });
  }
}

export function saveSSHSettings(settings, serviceUrl) {
  const url = serviceUrl + '/server/ssh';
  return function (dispatch) {
    return axios.post(url, settings, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
        dispatch(getSSHSettings(serviceUrl));
      })
      .catch(err => {
        let errMsg = err.message;
        var msg;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          msg = `Successfully saved the network setting!`;

        if (msg) {
          dispatch(addNotification(msg, 'success'));
        } else {
          dispatch(addNotification(errMsg, 'error'));
        }
      });
  }
}

export function execServerAction(data, serviceUrl) {
  const url = serviceUrl + '/server';
  return function (dispatch) {
    var actionData = Object.assign({username: 'appuser'}, data);
    return axios.post(url, actionData, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        if(res.data === 'Successfully verified') {
          if(data.action === 'update') {
            dispatch(execServerActionSuccess({showUpdateModal: true}));
          }
        } else {
          dispatch(addNotification(res.data, 'success'));
        }
      })
      .catch(err => {
        let errMsg = err.message;
        var msg, statusCode;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (err.response && err.response.status)
          statusCode = err.response.status

        if (!(errMsg instanceof Object) && errMsg && (errMsg.startsWith("Network Error") || statusCode == "502")) {
          var action = '';
          if(data.action === "poweroff") {
            action = 'shutdown';
          } else if(data.action === "reboot") {
            action = 'reboot';
          } else if(data.action === "reset") {
            action = 'factory default';
          }
          msg = `Successfully executed ${action} command`;
        }
        
        if (msg) {
          dispatch(addNotification(msg, 'success'));
        } else {
          dispatch(addNotification(errMsg, 'error'));
        }
      });
  }
}

export function downloadContainersBackup(serviceUrl){
  const url = `${serviceUrl}/stream/backups/download`;
  var link=document.createElement('a');
  link.href = url;
  link.download = url.substr(url.lastIndexOf('/') + 1);
  //link.target="_blank"
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
  }, 100);
  return function(dispatch){
  }
}

export function clearContainersBackup(serviceUrl){
  const url = serviceUrl + '/stream/backups/clear';
  return function (dispatch) {
    return axios.get(url, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
      })
      .catch(err => {
        let errMsg = err.message;

        if (err.response && err.response.data)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          errMsg = `Unable to connect to the engine service!`;


        dispatch(addNotification(errMsg, 'error'));

        //dispatch(getSSHSettingsFailure(err))
      });
  }
}

export function uploadFile(data, serviceUrl) {
  const url = serviceUrl + '/stream/backups/upload';
  return function (dispatch) {
    return axios.post(url, data, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
      })
      .catch(err => {
        let errMsg = err.message;
        var msg;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (msg) {
          dispatch(addNotification(msg, 'success'));
        } else {
          dispatch(addNotification(errMsg, 'error'));
        }

      });
  }
}

export function uploadUpdateFile(data, serviceUrl, uploadProgress) {
  const url = serviceUrl + '/server/update';
  return function (dispatch) {
    return axios.post(url, data, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: uploadProgress
      })
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
        //dispatch(saveNetowrkSettingsSuccess(res.data));
      })
      .catch(err => {
        let errMsg = err.message;
        var msg;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (msg) {
          dispatch(addNotification(msg, 'success'));
        } else {
          dispatch(addNotification(errMsg, 'error'));
        }

      });
  }
}

export function updateProps(state) {
  return function (dispatch) {
    dispatch(execServerActionSuccess({...state}));
  }
}